/* @ngInject */
const labels = (
  types,
  invoicingLabels,
  icons
) => {
  const self = {}

  self.owner = {
    ref: 'owner',
    label: invoicingLabels.fields.owner.text,
    icon: icons.invoicing.owner,
    type: types.select,
    options: 'owner as owner.society for owner',
    order: 'society.toString()',
    messages: invoicingLabels.fields.owner.messages,
    required: true,
  }

  self.dateBegin = {
    ref: 'dateBegin',
    label: invoicingLabels.fields.dateBegin.text,
    type: types.date,
    required: true,
  }

  self.dateEnd = {
    ref: 'dateEnd',
    label: invoicingLabels.fields.dateEnd.text,
    type: types.date,
    required: true,
  }

  self.provisionCost = {
    ref: 'provisionCost',
    label: invoicingLabels.fields.provisionCost.text,
    type: types.decimal,
    required: true,
  }

  self.unparkCost = {
    ref: 'unparkCost',
    label: invoicingLabels.fields.unparkCost.text,
    type: types.decimal,
    required: true,
  }

  self.linearMeterCost = {
    ref: 'linearMeterCost',
    label: invoicingLabels.fields.linearMeterCost.text,
    type: types.decimal,
  }

  self.fixedPartCost = {
    ref: 'fixedPartCost',
    label: invoicingLabels.fields.fixedPartCost.text,
    type: types.decimal,
  }

  self.wagonCost = {
    ref: 'wagonCost',
    label: invoicingLabels.fields.wagonCost.text,
    type: types.decimal,
  }

  self.limitWagonLength = {
    ref: 'limitWagonLength',
    label: invoicingLabels.fields.limitWagonLength.text,
    type: types.decimal,
  }

  self.fixedPartLength = {
    ref: 'fixedPartLength',
    label: invoicingLabels.fields.fixedPartLength.text,
    type: types.decimal,
  }

  return self
}

export default labels



// WEBPACK FOOTER //
// ./public/javascript/sygem/invoicing/resources/fields.resource.js